import PropTypes from "prop-types";
import React from "react";

import { classNames } from "@swa-ui/string";

import colors from "../../defines/colors";

/**
 * Logo renders the Southwest logo.
 */

const Logo = (props) => {
  const { className, fillColor, height, role, strokeColor, style, width } = props;

  return (
    <svg {...getProps()}>
      <path d="M59,27.005c-0.91,0.17-1.972,0.319-3.114,0.319c-3.192-0.004-3.895-1.102-3.894-3.168V11.995h-6.006    l-0.012,12.762c-0.005,5.66,3.167,8.254,9.623,8.261c3.132,0.002,6.045-0.576,9.464-1.449V11.995H59V27.005z M78.497,27.563    c-2.184-0.002-2.485-1.03-2.484-2.678l0.007-7.845l4.982,0.005v-5.05H76.02V5.986h-6.016v6.008l-3.035,0.001v5.037l3.035,0.003    l-0.007,8.238c-0.003,3.627,0.734,7.761,6.708,7.766c1.827,0.002,3.32-0.438,4.952-0.9l-0.598-5.002    C80.175,27.393,79.401,27.563,78.497,27.563z M15.444,16.317c-1.113-0.426-2.355-0.826-3.687-1.194    c-3.506-0.99-4.585-1.543-4.584-3.082c0.001-1.818,1.35-2.653,4.494-2.65c2.583,0.002,4.878,0.67,7.212,1.547l1.262-5.891    c-2.69-1.002-5.245-1.895-8.344-1.897C4.561,3.144,0.57,7.255,0.565,12.188c-0.003,3.654,1.648,6.136,5.21,7.576    c1.046,0.422,2.252,0.84,3.588,1.233c3.928,1.206,5.072,1.771,5.071,3.282c-0.001,1.832-1.498,2.808-4.576,2.805    c-2.829-0.003-5.43-0.781-8.15-2.032l-1.259,5.943c2.969,1.172,5.926,2.041,9.483,2.044c7.362,0.007,11.181-4.115,11.185-9.063    C21.121,19.93,18.839,17.616,15.444,16.317z M94.227,10.954c-1.972-0.002-3.856,0.456-5.193,0.92V1.975h-6.007v31.013h5.988    l0.013-15.546c1.083-0.415,2.333-0.825,3.811-0.824c2.339,0.002,3.185,0.899,3.183,3.084l-0.011,13.286H102l0.011-13.939    C102.016,13.57,99.542,10.958,94.227,10.954z M33.419,10.855c-6.074-0.005-10.977,4.26-10.983,11    c-0.006,6.742,4.873,11.179,10.963,11.184c6.086,0.006,10.973-4.407,10.979-11.163S39.488,10.861,33.419,10.855z M33.404,27.139    c-2.611-0.002-4.702-1.878-4.699-5.275s2.029-5.188,4.708-5.186c2.675,0.002,4.658,1.771,4.655,5.192    C38.066,25.296,36.013,27.143,33.404,27.139z M168.117,20.206c-0.855-0.297-1.816-0.604-2.863-0.906    c-2.104-0.554-2.92-0.907-2.919-1.774c0.001-0.915,0.815-1.524,2.665-1.523c1.986,0.002,3.816,0.411,5.777,0.979l0.955-5.188    c-2.162-0.473-4.303-0.889-6.729-0.892c-5.688-0.005-8.75,2.906-8.754,6.876c-0.002,2.82,1.367,4.602,4.203,5.801    c0.801,0.341,1.743,0.686,2.812,1.021c2.217,0.64,3.297,0.9,3.297,1.901c-0.002,0.953-1.314,1.386-3.074,1.384    c-2.166-0.002-4.188-0.355-6.275-1.178l-0.934,5.154c2.584,0.736,5.008,1.22,7.697,1.222c5.981,0.006,8.664-3.128,8.668-6.995    C172.646,23.441,171.505,21.396,168.117,20.206z M145.557,10.879c-6.348-0.006-10.752,4.418-10.758,11.387    c-0.005,6.502,3.922,10.791,10.863,10.797c3.102,0.002,5.631-0.867,8.232-1.974l-0.902-4.967c-1.96,0.882-3.987,1.569-6.354,1.567    c-3.578-0.004-5.052-1.541-5.283-3.713l13.483,0.012c0,0,0.195-2.446,0.195-2.922C155.041,15.407,151.904,10.884,145.557,10.879z     M141.441,19.967c0.383-1.842,1.342-4.124,3.865-4.122c2.6,0.003,3.383,2.64,3.45,4.128L141.441,19.967z M184.49,27.563    c-2.184-0.002-2.473-1.03-2.471-2.678l0.008-7.797l5.039,0.005v-5.098h-5.041V5.986h-6.027v6.008l-3.063,0.001v5.085l3.063,0.003    l-0.008,8.19c-0.004,3.627,0.877,7.761,6.851,7.766c1.827,0.002,3.333-0.438,4.966-0.9l-0.742-5.002    C186.182,27.393,185.395,27.563,184.49,27.563z M188.49,3.219c-1.461-0.001-2.65,1.188-2.652,2.655s1.188,2.657,2.646,2.659    c1.469,0.001,2.658-1.188,2.66-2.655S189.957,3.221,188.49,3.219z M188.484,8.063c-1.23-0.001-2.148-0.892-2.148-2.188    c0.002-1.289,0.922-2.187,2.152-2.185c1.24,0.001,2.152,0.899,2.15,2.188C190.639,7.174,189.725,8.063,188.484,8.063z     M188.814,5.997c0.457-0.07,0.764-0.341,0.764-0.804c0-0.506-0.355-0.891-1.032-0.892L187.498,4.3l-0.002,3.084l0.57,0.001V6.067    c0.207,0.001,0.285,0.064,0.428,0.293l0.662,1.026h0.654l-0.633-0.955C189.035,6.218,188.93,6.083,188.814,5.997z M188.367,5.655    l-0.301-0.001l0.002-0.897l0.392,0.001c0.386,0,0.521,0.179,0.521,0.449C188.979,5.584,188.688,5.655,188.367,5.655z     M129.229,11.995l-3.754,11.548l-3.887-11.548h-5.238l-3.886,11.548l-3.755-11.548h-6.527l7.453,20.991h5.539L119,21.625    l3.766,11.361h5.539l7.452-20.991H129.229z" />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className: classNames(className),
      fill: fillColor,
      height,
      role,
      stroke: strokeColor,
      style,
      viewBox: "0 0 192 34",
      width,
    };
  }
};

Logo.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Color name from color palette or name of an entry in color theme file, themes.js. */
  fillColor: PropTypes.oneOfType([PropTypes.oneOf(Object.keys(colors)), PropTypes.string]),

  /** Indicates SVG's height. The width, if not given, will be sized according to SVG's aspect ratio. */
  height: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Color name from color palette or name of an entry in color theme file, themes.js. */
  strokeColor: PropTypes.oneOfType([PropTypes.oneOf(Object.keys(colors)), PropTypes.string]),

  /** Indicates SVG's width. The height, if not given, will be sized according to SVG's aspect ratio. */
  width: PropTypes.string,
};

Logo.defaultProps = {
  fillColor: colors["primary-500"],
  height: "32",
  role: "img",
};

export { Logo };
